export default __webpack_public_path__ + "static/media/darksquare.b1b44604.svg";